export default __webpack_public_path__ + "static/fullscreenDarkActive.png";